<template>
  <div class="content-block">
    <div class="asd-form-section">
      <div class="section-title">
        <h5>
          <i class="fas fa-copy"></i>
          Samba složky pro typ projektu {{ projectType.name }}
        </h5>
        <div class="section-title-controls">
          <ActiveButton v-help.mouse="'Uložit nastavení'"
                        class="asd-btn-confirm"
                        :click="save"
          >
            <i class="fas fa-save"></i>
          </ActiveButton>
          <ActiveButton v-help.mouse="'Zrušit'"
                        class="asd-btn-cancel"
                        :click="cancel"
          >
            <i class="fas fa-times"></i>
          </ActiveButton>
          <ActiveButton v-help.mouse="'Vyresetovat nastavení složek'"
                        class="asd-btn-delete"
                        :click="reset"
          >
            <i class="fas fa-recycle"></i>
          </ActiveButton>
        </div>
      </div>
      <div style="margin: 10px">
        <SambaFolders v-model="folders"></SambaFolders>
      </div>
    </div>
  </div>
</template>

<script>
import { get, cloneDeep } from 'lodash'
import SambaFolders from './folders'
import ActiveButton from 'CORE/components/form/active-button'
import ensurePath from 'CORE/utils/ensure-path'

const ROOT_FOLDER = { name: null, children: [] }

export default {
    name: 'SambaGlobalSettings',
    components: {
        ActiveButton,
        SambaFolders,
    },
    props: {
        projectTypeId: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            projectType: {},
            folders: null,
        }
    },
    computed: {
        defaultRWOptions() {
            return [
                { id: '', label: 'nic' },
                { id: 'r', label: 'čtení' },
                { id: 'rw', label: 'čtení a zápis' },
            ]
        },
    },
    created() {
        this.projectType = this.$store.getters.projectTypeById(this.projectTypeId)

        this.folders = get(
            this.$store.getters.settings,
            `files.overrides.${this.projectTypeId}`,
            cloneDeep(ROOT_FOLDER)
        )
    },
    methods: {
        async save() {
            try {
                const data = this.$store.getters.settings

                ensurePath(data, ['files/Object', 'overrides/Object', `${this.projectTypeId}/Object`])

                data['files']['overrides'][this.projectTypeId] = this.folders

                await this.$store.dispatch('saveCurrentUserCompanySettings', data)
                this.flash('Uloženo', 'success', {
                    timeout: 1500,
                })
                this.$emit('done')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        async cancel() {
            this.$emit('cancel')
        },
        async reset() {
            this.folders = cloneDeep(ROOT_FOLDER)
        },
    },
}
</script>

<style lang="scss">
.samba-settings-grid {
    display: grid;
    grid-auto-rows: minmax(60px, auto);
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 5px 20px;
}
</style>
